// extracted by mini-css-extract-plugin
export default {"content":"App_content_lf7yS","loading":"App_loading_SrPFd"};